import { useState, useEffect } from 'react'
import axios from 'axios'
import sanitize from 'sanitize-filename'
import { useParams, useSearchParams } from 'react-router-dom'
import httpClient from '../httpClient'

import ImagesUpload from '../components/PrintOrder/PrintOrderCreate/ImagesUpload'
import NoImages from '../components/PrintOrder/PrintOrderCreate/NoImages'
import Loading from '../components/common/Loading'
import ImagePreview from '../components/PrintOrder/PrintOrderCreate/ImagePreview'
import SelectProducts from '../components/PrintOrder/PrintOrderCreate/SelectProducts'
import { apiErrorMessage } from '../lib/utils'

const PrintOrderCreate = () => {
  const { id: labOrderGuid } = useParams()
  const [searchParams] = useSearchParams()
  const uploadProductType = searchParams.get('productType') || 'default'

  const [uploadsPreview, setUploadPreview] = useState([])
  const [loading, setLoading] = useState(false)
  const [, setApiError] = useState(false)

  const handleUploadPhoto = async (files) => {
    try {
      setLoading('Uploading')
      setApiError(null)

      await Promise.all(
        files.map(async (file) => {
          const photoFileName = sanitize(file.name)
          const tempId = `${Date.now()}-${Math.random()}`
          const placeholderPreview = {
            id: tempId,
            preview: '',
            path: file.name,
            uploading: true,
          }

          setUploadPreview((prev) => [...prev, placeholderPreview])

          const { signedUrl } = await httpClient.post(
            `lab_orders/${labOrderGuid}/create_presigned_url`,
            {
              labOrderGuid,
              photoFileName,
              productType: uploadProductType,
            },
          )

          await axios.put(signedUrl, file, {
            headers: {
              'Content-Type': file.type,
            },
          })

          const { status, id } = await httpClient.patch(
            `lab_orders/${labOrderGuid}/photograph_uploaded`,
            {
              labOrderGuid,
              photoFileName,
            },
          )

          if (status === 'ok') {
            const uploaded = {
              ...file,
              id,
              path: file.name,
              preview: URL.createObjectURL(file),
              uploading: false,
            }

            setUploadPreview((prev) =>
              prev.map((img) => (img.id === tempId ? uploaded : img))
            )
          }
        })
      )

      setLoading(false)
    } catch (err) {
      setLoading(false)
      setApiError(apiErrorMessage(err))
    }
  }

  const handleDeletePhoto = (id) => {
    setUploadPreview((prev) => prev.filter((image) => image.id !== id))
  }

  // TODO: Error notification
  // TODO: Success notification

  useEffect(
    () => () => {
      uploadsPreview.forEach((file) => URL.revokeObjectURL(file.preview))
    },
    [],
  )

  return (
    // below this div
    <div className="sub-grid-container-print-order"> 
      <div className="print-order-sidebar-container">
        <div className="print-order-sidebar grid absolute">
          <div className="accordion-item-block">
          <ImagesUpload onUpload={handleUploadPhoto} productType={uploadProductType} />
            {!!uploadsPreview.length && <SelectProducts id={labOrderGuid} />}
          </div>
        </div>
      </div>
      {uploadsPreview.length > 0 && (
        <div className="img-container-print-order">
          <div className="w-layout-grid grid-images-print-order">
            {uploadsPreview.map((preview, index) => (
              <ImagePreview
                key={`preview-${index}`}
                image={preview}
                labOrderGuid={labOrderGuid}
                productType={uploadProductType}
                onDeleted={handleDeletePhoto}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default PrintOrderCreate
